import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Home, ArrowLeft, Search } from "lucide-react";
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const NotFoundPage = () => {
    const navigate = useNavigate();

    // Set document title
    useDocumentTitle('404 - Sidan hittades inte');

    return (
        <div className="container-fluid vh-100 d-flex align-items-center justify-content-center bg-light">
            <div className="text-center">
                <div className="mb-4">
                    <h1 className="h2 text-dark mb-3">Sidan hittades inte</h1>
                    <p className="lead text-muted mb-4">
                        Den sida du letar efter finns inte eller har flyttats.
                    </p>
                </div>
                
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mb-4">
                    <Link to="/" className="btn btn-primary btn-lg">
                        <Home size={20} className="me-2" />
                        Tillbaka till startsidan
                    </Link>
                    <button 
                        className="btn btn-outline-secondary btn-lg"
                        onClick={() => navigate(-1)}
                    >
                        <ArrowLeft size={20} className="me-2" />
                        Gå tillbaka
                    </button>
                </div>

                <div className="text-muted">
                    <Search size={16} className="me-2" />
                    <small>Kontrollera URL:en eller använd navigationsmenyn för att hitta det du söker</small>
                </div>
            </div>
        </div>
    );
};

export default NotFoundPage;
